<span
  class="bn-button-dropdown bn-button-dropdown--{{ size }}"
  [ngClass]="{ 'bn-button-dropdown--disabled': disabled }">
  <bn-web-ui-button
    class="bn-button-dropdown__button"
    [active]="active"
    [disabled]="disabled"
    [fullWidth]="fullWidth"
    [itemStyle]="itemStyle"
    [leftIcon]="leftIcon"
    [lessPadding]="lessPadding"
    [loading]="loading"
    [noEllipsis]="noEllipsis"
    [rightIcon]="rightIcon"
    [size]="size"
    (click)="onButtonAction()">
    <ng-content
  /></bn-web-ui-button>
  <div class="bn-button-dropdown__dropdown bn-button-dropdown__dropdown__item-style--{{ itemStyle }}">
    @if (dropdownItems) {
      <bn-web-ui-dropdown-menu
        class="h-100 w-100"
        [aboveLoader]="true"
        [items]="dropdownItems"
        [options]="{
          size: dropdownSize ?? 'sm',
          attachArrow: true,
          noMarginArrow: true,
          align: 'end',
          indent: '-10px',
          isFullSize: true,
        }"
        [uploadData]="uploadData"
        (clickAction)="onDropdownAction($event)" />
    }
    @if (routerLink) {
      <a [routerLink]="routerLink">
        @if (rightIcon) {
          <fa-icon [icon]="rightIcon" />
        }
      </a>
    }
  </div>
</span>
